import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const navItems = [
  { path: '/clients', label: 'Clients', icon: 'fa-users' },
  { path: '/jobs', label: 'Jobs', icon: 'fa-briefcase' },
  { path: '/quotes', label: 'Quotes', icon: 'fa-file-invoice' },
  { path: '/change-orders', label: 'Change Orders', icon: 'fa-file-signature' },
  { path: '/invoices', label: 'Invoices', icon: 'fa-receipt' },
  { path: '/calendar', label: 'Calendar', icon: 'fa-calendar-alt' },
  { path: '/reports', label: 'Reports', icon: 'fa-chart-bar' },
  { path: '/templates', label: 'Templates', icon: 'fa-file-alt' },
];

function SecondaryNav() {
  const location = useLocation();
  const { canCreateData, isPremium, loading } = useUser();

  const isActive = (path) => location.pathname === path;

  // Show upgrade button when trial has expired (can't create data and not premium)
  const showUpgradeButton = !loading && !canCreateData && !isPremium;

  return (
    <nav className="bg-white border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center space-x-1 overflow-x-auto scrollbar-hide">
          {/* Upgrade Button - appears when trial expired */}
          {showUpgradeButton && (
            <Link
              to="/upgrade"
              className="flex items-center space-x-2 px-4 py-2 my-1 mr-2 bg-secondary text-white font-bold rounded-lg whitespace-nowrap transition-all hover:bg-orange-600 shadow-md animate-pulse"
            >
              <i className="fas fa-crown text-sm"></i>
              <span>Upgrade to Pro</span>
            </Link>
          )}
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center space-x-2 px-4 py-3 font-medium whitespace-nowrap transition-colors border-b-2 ${
                isActive(item.path)
                  ? 'text-secondary border-secondary'
                  : 'text-slate-600 border-transparent hover:text-primary hover:border-slate-300'
              }`}
            >
              <i className={`fas ${item.icon} text-sm`}></i>
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default SecondaryNav;
